'use client';

import React from 'react';

import { useGetDelivery } from '@/common/apis/dedicated-personal-page/delivery.api';
import DedicatedPersonalPage from '@/common/components/dedicated-personal-page/dedicated-personal-page.component';
import Loading from '@/common/components/loading';

const Delivery = () => {
  const { data, isLoading } = useGetDelivery();

  if (isLoading) return <Loading />;

  const content = data?.data.content;

  return (
    <DedicatedPersonalPage content={content} title="پیگیری سفارش و ارسال" />
  );
};

export default Delivery;
